import { Text, Tooltip } from '@mantine/core';

export function AutoUpdateIndicator() {
  return (
    <Tooltip
      label="Data connections usually update daily"
      position="bottom"
      withArrow
    >
      <Text
        size="md"
        c="dimmed"
        style={{ cursor: 'help' }}
      >
        Last update: Auto (daily)
      </Text>
    </Tooltip>
  );
}